<template>
<v-dialog v-model="dialog" persistent max-width="560px">
    <v-card>
        <v-card-title class="headline">Credit card</v-card-title>
        <v-card-text>
            <div class="warn-message pb-3 px-1">Aveti un numar limitat de vizualizari pentru acest card({{viewed}}/3).</div>
            <div class="d-flex align-center justify-center  fill-height">
                <div>
                    <div class="credit-card card-front">
                        <div class="card-number">{{credit_card.number}}</div>
                        <div class="card-owner">{{credit_card.holder}}</div>
                        <div class="d-flex justify-space-between align-center">
                            <div>
                                <div class="info-title">EXP DATE</div>
                                <div>{{ credit_card.month }}/{{ credit_card.year }}</div>
                            </div>
                            <div>
                                <div class="info-title">CVV</div>
                                <div>{{credit_card.cvv}}</div>
                            </div>
                            <img height="50px" :src="logo_card">
                        </div>
                    </div>
                </div>
            </div>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="emitExit()">{{ $t('button.exit') }}</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
// import cards
import Maestro from "../../../assets/cards/maestro-logo.svg";
import MasterCard from "../../../assets/cards/mastercard-logo.svg";
import Visa from "../../../assets/cards/visa3-logo.svg";
import AMEX from "../../../assets/cards/amex-logo.svg";

export default {
    components: {},

    props: {
        reservation_id: [Number, String],
        dialog: {
            type: Boolean,
            default: false
        },
    },

    data: () => {
        return {
            no_show: false,
            loading: false,
            maestro: Maestro,
            amex: AMEX,
            mastercard: MasterCard,
            visa: Visa,
            logo_card: MasterCard,
            viewed: 3,
            credit_card: {
                number: "0000 0000 0000 0000",
                holder: "Owner",
                month: "00",
                year: "0000",
                cvv: "000"
            },
        }
    },
    watch: {
        dialog: {
            handler(newValue, oldValue) {
                if(newValue) {
                    this.callCCInfo(this.reservation_id);
                } else {
                    this.viewed = 3;
                    this.credit_card = {
                        number: "0000 0000 0000 0000",
                        holder: "Owner",
                        month: "00",
                        year: "0000",
                        cvv: "000"
                    }
                }
            }
        }
    },

    methods: {

        callCCInfo(value) {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/reservations/' + value + '/cc-info';

            this.$axios.get(endpoint)
                .then(response => {
                    if(response.data.data) {
                        let number = response.data.data.number;
                        this.viewed = response.data.viewed;
                        this.credit_card.cvv = response.data.data.cvv;
                        this.credit_card.year = response.data.data.year;
                        this.credit_card.month = response.data.data.month;
                        this.credit_card.holder = response.data.data.holder;
                        this.credit_card.number = number.slice(0, 4) + " " + number.slice(4, 8) + " " + number.slice(8, 12) + " " + number.slice(12);
                        this.ccLogo(number);
                    }
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {});
        },

        ccLogo(value) {
            let visaRegEx = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
            let mastercardRegEx = /^(?:5[1-5][0-9]{14})$/;
            let amexpRegEx = /^(?:3[47][0-9]{13})$/;
            let maestroRegEx = /^(5018|5020|5038|6304|6759|6761|6763)[0-9]{8,15}$/;

            switch (true) {
            case visaRegEx.test(value):
                this.logo_card = this.visa;
                break;
            case mastercardRegEx.test(value):
                this.logo_card = this.mastercard;
                break;
            case amexpRegEx.test(value):
                this.logo_card = this.amex;
                break;
            case discovRegEx.test(value):
                this.logo_card = this.maestro;
                break;
            default:
                this.logo_card = this.visa;
            }
        },

        emitExit() {
            this.$emit('close');
        }
    },


}
</script>

<style lang="stylus">
.warn-message
    text-align: center
    font-size: 16px
    color: orange
.credit-card
    width: 300px
    height: 186px
    position: relative
    display: inline-block
    vertical-align: middle
    text-align: left
    padding: 20px;
    margin-bottom: 50px
    color: #fff
    border-radius: 20px
    box-sizing: border-box
    background: linear-gradient(to right, #202020  5%, 	#404040 100%)
    &.card-front
        .card-number
            white-space: nowrap
            font-size: 22px
            padding-top: 30px
            text-align: center
        .card-owner
             text-align: left
             padding-top: 10px
             padding-bottom: 5px
        .info-title
            font-size: 10px
    &.card-back
        padding-left: 0
        padding-right: 0
        text-align: left
        .card-strip
            background: #000
            height: 30px
            margin-bottom: 20px
        .card-signature
            float: left
            width: 65%
            height: 27px
            margin-left: 10px
            background: #999
        .card-ccv
            float: left
            margin-top: 2px
            padding: 4px
            background: #fff
            color: #111
            line-height: 1
</style>
